import React from 'react';
import { Navbar } from '../components/Navbar';
import { ArticlePage } from '../components/ArticlePage';
import { Footer } from '../components/Footer';
export const Article = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2333">
      <Navbar data-id="element-2334" />
      <ArticlePage data-id="element-2335" />
      <Footer data-id="element-2336" />
    </div>;
};